import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';

class UpdateUserDataSharingConsent extends baseRequest
{
    constructor(updateState) {
        super();
        this.name = 'UpdateUserDataSharingConsent';
        this.dispatch = null;
        this.response = null;
        this.config = new AppConfig();
        this.updateState = updateState;
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.config.api.requests.updateUserDataSharingConsent, payload);
    }

    onSuccess() {
        this.updateState(this.response.data);
    }
}

export default UpdateUserDataSharingConsent;
